import React from 'react';
import { compose } from 'redux';
import { Grid, Typography, Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { FieldNames } from 'app/models/fields/names';
import { WithTranslation, withTranslation, Trans } from 'react-i18next';
import { Button } from '../Button';
import {
  overdraftProtectionRecordAuditEventAndRedirect,
} from '../../actions/form/overdraft-protection/actions';
import { connect } from 'react-redux';

const styles = (theme: Theme) => createStyles({
  resultsList: {
    marginTop  : '10px',
    listStyle  : 'none',
    fontSize   : '1.15rem',
    lineHeight : '1.75rem',
    '& span'   : {
      paddingLeft: '5px',
    },
    [theme.breakpoints.up('sm')] : {
      paddingBottom: '30px',
    },
  },
});

type DispatchProps = typeof mapDispatchToProps;
interface Props extends WithStyles<typeof styles>, WithTranslation, DispatchProps {
  values: any;
}
class OverdraftProtectionCreditReportResultComponent extends React.Component<Props, any> {

  render() {
    const { classes, values, overdraftProtectionRecordAuditEventAndRedirect } = this.props;
    const loanAmount                                               = values[FieldNames.loanAmount];
    const rate                                                     = values[FieldNames.rate];
    const monthlyPayment                                           = values[FieldNames.monthlyPayment];
    const email                                                    = values[FieldNames.email];
    const firstName                                                = values[FieldNames.firstName];
    const middleName                                               = values[FieldNames.middleName];
    const lastName                                                 = values[FieldNames.lastName];

    return (
      <Grid container={false}>
        <Grid item>
          <Typography variant='body2' paragraph={true}>
            <Trans i18nKey='OverdraftProtection.creditReport.paragraph1'>
              Please review your loan terms which may have changed as a result of your credit score and/or other factors.
            </Trans>
          </Typography>
          <ul className={classes.resultsList}>
            <li>
              <strong>Loan Amount</strong>:
              <span>
                <Trans i18nKey='OverdraftProtection.creditReport.displayLoanAmount' values={{ loanAmount }}>
                  {'{{ loanAmount, currency.0 }}'}
                </Trans>
              </span>
            </li>
            <li>
              <strong>Overdraft Protection Rate</strong>:
              <span>
                <Trans i18nKey='OverdraftProtection.creditReport.displayRate' values={{ rate }}>
                  {'{{ rate, percent.3 }}'}
                </Trans>
              </span>
            </li>
            <li>
              <strong>Monthly Payment</strong>:
              <span>
                <Trans i18nKey='OverdraftProtection.creditReport.displayMonthlyPayment' values={{ monthlyPayment }}>
                  {'{{ monthlyPayment, currency.2 }}'}
                </Trans>
              </span>
            </li>
          </ul>
          <Typography variant='body2' paragraph={true}>
            <Trans i18nKey='OverdraftProtection.creditReport.finalStepMessage'>
              Your pre-qualification is based on the data you have provided including personal information, housing
              situation and income.  If the data you used for the pre-qualification changes at any time, please contact
              us immediately so we can address the modifications.  Please note that interest rates are subject to change
              without notice and may affect the loan amount for which you qualify. This pre-qualification is not a
              guarantee of final loan approval which is subject to a review of credit data, identity, income and other
              information.  Please acknowledge this by clicking on the "Continue" button below.  Thanks!
            </Trans>
          </Typography>
        </Grid>
        <Typography align='center' paragraph={true}>
          <Button
            classes  = {{ root: 'longButton' }}
            color    = 'primary'
            variant  = 'contained'
            rel      = 'noopener'
            onClick = {() => overdraftProtectionRecordAuditEventAndRedirect({ email, firstName, middleName, lastName })}>
            Continue
          </Button>
        </Typography>
      </Grid>
    );
  }
}

const mapDispatchToProps = {
  overdraftProtectionRecordAuditEventAndRedirect,
};

export const OverdraftProtectionCreditReportResult = compose(
  withStyles(styles),
  withTranslation(),
  connect(null,mapDispatchToProps),
)(OverdraftProtectionCreditReportResultComponent);
